import { IEntity, ENTITIES, ICompany } from 'interfaces'
import DefaultComponent from './pages'
import Routes from './routes'
import buildTheme from 'theme'
import { routeCodes } from 'constants/routes'

const { theme, materialTheme, logo } = buildTheme(ENTITIES.WORKER)
export const WorkerEntity: IEntity = {
  id: ENTITIES.WORKER,
  name: 'Trabalhador',
  path: routeCodes.ENTITY.WORKER,
  theme,
  materialTheme,
  logo,
  permissions: [],
  component: DefaultComponent,
  route: Routes,
  company: {} as ICompany,
}

export default WorkerEntity
